@use 'styles/functions/rem' as *;

.pill {
    align-items: center;
    border-radius: var(--pill-border-radius);
    display: inline-flex;
    flex-shrink: 0;
    gap: rem(5px);
    padding: var(--pill-padding);
}
